import * as yup from 'yup';

export const VaccineSchema = yup.object({
  name: yup.string().required(),
  date: yup.string().required(),
});

export interface IVaccine {
  name: string;
  date: string;
}
